const requireAll = (context) => context.keys().map(context);

// require the rest of the components
requireAll(require.context('@wellness-tags/Sitecore', true, /\.css$/));
requireAll(require.context('@wellness-components/Awesomecomplete', true, /\.css$/));
